import {processFeatureData} from '../lib/featureData'
import {declOfNumber} from '../lib/numerals'
import {allowedStates} from './_variables'
import type {FinalData} from './load_data'
import type Map from 'ol/Map'
import type {Pixel} from 'ol/pixel'

const generatePlotInfo = (cls: string, title: string, content: string) => {
  return `<div class="plot-info plot-info--${cls}">
               <strong class="plot-info__title">${title}:</strong>
               <span class="plot-info__content">${content}</span>
             </div>`
}

const repositionTooltip = ($tip: JQuery<HTMLElement>, pixel: Pixel) => {
  const rect = $tip[0].getBoundingClientRect()
  if (rect.bottom > window.innerHeight) {
    $tip.css('top', (pixel[1] - (rect.bottom - window.innerHeight)) + 'px')
  }

  if (rect.right > window.innerWidth) {
    const leftPos = pixel[0] - 10 - rect.width
    if (leftPos > 0) {
      $tip.css('left', leftPos + 'px')
    }
  }
}

export const showTip = (map: Map, $tip: JQuery<HTMLElement>, data: FinalData) => {
  /**
   * Add a click handler to the map to render the popup.
   */
  map.on('pointermove', function (event_) {
    if (event_.dragging) {
      // the event is a drag gesture, this is handled by openlayers (map move)
      return
    }

    const feature = map.forEachFeatureAtPixel(event_.pixel,
      function (feature_) {
        if (feature_.get('type') === 'Special') {
          return null
        } else {
          return feature_
        }
      })
    if (feature) {
      const featureName = feature.get('name')
      const processedFeature = processFeatureData(feature, data.plots[featureName])
      const pixel = map.getEventPixel(event_.originalEvent)
      $tip.css('left', pixel[0] + 10 + 'px')
      $tip.css('top', pixel[1] + 'px')
      let tipContent = ''
      if (feature.get('type') === 'Entrance' && data.entrance?.gpsCoords) {
        tipContent = 'Нажмите, чтобы получить координаты'
      } else {
        tipContent = `<header class="map-tip__header"><h4 class="map-tip__title">Участок №${featureName}</h4></header>`
        if (processedFeature.status) {
          tipContent += `<div class="plot-status plot-status--${processedFeature.status.state}">
                                           ${processedFeature.status.name}
                                        </div>`
        }

        if (processedFeature.status?.state && allowedStates.includes(processedFeature.status.state)) {
          if (processedFeature.area) {
            const areaSotNumber = Math.floor(Number.parseFloat(processedFeature.area))
            const areaSot = declOfNumber(areaSotNumber, ['сотка', 'сотки', 'соток'])
            tipContent += generatePlotInfo('area', 'Площадь', `${processedFeature.area}&nbsp;${areaSot}`)
          }

          if (processedFeature.priceTotalNum && processedFeature.priceTotalNum > 0) {
            let content = processedFeature.priceTotalNum.toLocaleString() + '₽'
            if (processedFeature.priceTotalDiscountNum && processedFeature.priceTotalDiscountNum > 0) {
              content = `<s class="price-total__old">${content}</s> <span class="price-total__discounted">${processedFeature.priceTotalDiscountNum.toLocaleString() + '₽'}</span>`
            }

            tipContent += generatePlotInfo('price-total', 'Цена за участок', content)
          }

          tipContent += '<footer class="map-tip__footer">Кликните на участок для подробной информации</footer>'
        }
      }

      $tip.html(tipContent)
      $tip.addClass('map-tip--visible')

      repositionTooltip($tip, pixel)
    } else {
      $tip.removeClass('map-tip--visible')
      $tip.html('')
    }
  },
  )
}
